var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('dashboard-core-drawer',{attrs:{"expand-on-hover":_vm.expandOnHover}}),_c('dashboard-core-app-bar',{attrs:{"image":_vm.headerImage.getByEnvironment()}}),_c('dashboard-core-view'),_c('dashboard-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }